import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Formik, Form } from 'formik'
import { green } from '@mui/material/colors'
import { Forest } from '@mui/icons-material'
import { Grid, Box, Divider, Paper, FormControlLabel } from '@mui/material'
import { styled, Typography as MIUTypography } from '@mui/material'
import { updateFeatures } from '../../redux/slices/Tree/treeFeatures'
import { changePopup } from '../../redux/slices/Map/map'
import { getPropertiesByID } from '../../services'
import { setItemsFormik } from './datasetFormik'
import { handleSaveFormik } from '../../utils/formikUpdate'
import * as rt from '../../config/routeType'

import Botton from '../BottonCustom'
import LinearInderterminate from '../LinearIndeterminate'
import Switch from '../Select'
import ItemsContainer from '../ItemsContainer'
import TabsContainer from '../TabsContainer'
import AlertCustom from '../Alerts'
import BottonInside from '../BottonCustom/BottonInside'
import Backdrop from '../Backdrop'

const PROPERTIES_DEFAULT = 3
const COLOR_POPUP = 'var(--color-primary)'
const COLOR_SHOW = 'var(--color-primary)'
const COLOR_WHITE = '#fffafa'

const gridStyle = {
  mt: 0,
  width: '100%',
  ml: 0,
  textAlignLast: 'right',
  justifyContent: 'space-evenly',
  pr: 2,
}

const styleTitle = {
  py: 2,
  backgroundColor: 'var(--color-primary)',
  color: 'var(--color-white)',
}

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1em',
  fontWeight: 600,
  color: '#1B1C37',
}))

function getIndexOfFeature(id, data) {
  let idFeatureState = 0
  data.forEach((obj, key) => {
    if (obj.properties.id === id) idFeatureState = key
  })
  return idFeatureState
}

const styleDefault = (bg, c) => ({
  color: COLOR_POPUP,
  border: `1px solid ${COLOR_POPUP}`,
  width: '100%',
  fontSize: '12px',
  '&:hover': { backgroundColor: bg, color: c },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
})

const styleForHeader = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: 2,
  py: 1,
}

const ItemsFormik = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { treeId } = useParams()
  const alertRef = React.useRef()
  const backdropRef = React.useRef()
  const [formik, setFormik] = React.useState(null)
  const [isStored, setIsStored] = React.useState(null)
  const [isEditable, setIsEditable] = React.useState(false)
  const HEIGHT_PAPER = isEditable ? 'calc(100vh - 100px)' : 'calc(100vh - 40px)'
  const {
    temporal,
    data: stateGlobal,
    enableSaveButton: groupFieldAutocomplete,
  } = useSelector(state => state.treeFeatures)
  const filterEnable = useSelector(state => state.filterSearch.filter)

  const { draggable, lnglat } = useSelector(state => state.mapState.marker)
  const _featuresState = stateGlobal?.features
  const featureTreeCode = _featuresState?.filter(obj => obj.properties.id === treeId)

  const TOKEN = `Bearer ${window.localStorage.getItem('arbolQR_Token')}`
  const data = featureTreeCode?.[0]
  const { properties } = data || {}

  const labelSwitch = isEditable ? 'Deshabilitar edición.' : 'Habilitar edición.'
  const propsSwitch = {
    checked: isEditable,
    onChange: () => setIsEditable(!isEditable),
    colorMui: green,
    // custom: true,
  }

  const handleNewTreeForm = () => {
    navigate(`/${rt.MANAGEMENT_TREE}/${rt.TREE}/${rt.REGISTER_TREE}`, { replace: true })
  }

  React.useEffect(() => {
    getPropertiesByID(treeId)
      .then(propsByID => {
        dispatch(
          updateFeatures({
            someId: getIndexOfFeature(treeId, _featuresState),
            someValue: propsByID,
          })
        )
      })
      .catch(err => console.log(' Error :>> ', err.message))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeId])

  React.useEffect(() => {
    if (Boolean(formik)) return
    if (!properties) return
    if (Object.keys(properties).length > PROPERTIES_DEFAULT)
      setItemsFormik(data).then(variables => {
        setFormik(variables)
        dispatch(changePopup(true))
      })

    return () => {
      setIsEditable(false)
      setFormik(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [properties])

  React.useEffect(() => {
    if (!Boolean(isStored)) return
    setTimeout(() => {
      alertRef?.current?.openAlert(true)
    }, 1000)
  }, [isStored])

  React.useEffect(() => {
    if (!isEditable && draggable) setIsEditable(true)
  }, [isEditable, draggable])

  React.useEffect(() => {
    if (properties) return
    setTimeout(() => {
      navigate(`/${rt.MANAGEMENT_TREE}/${rt.TREE}`, { replace: true })
    }, 1000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [properties])

  React.useEffect(() => {
    if (!filterEnable) return
    if (!properties) return

    getPropertiesByID(treeId)
      .then(propsByID => {
        dispatch(
          updateFeatures({
            someId: getIndexOfFeature(treeId, _featuresState),
            someValue: propsByID,
          })
        )
      })
      .catch(err => console.log(' Error :>> ', err.message))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterEnable])

  if (!properties) return <LinearInderterminate />

  if (
    Object.keys(properties).length === PROPERTIES_DEFAULT ||
    !Boolean(formik) ||
    properties.code !== formik?.INITIAL_FORMIK_STATE?.code_
  )
    return <LinearInderterminate />

  return (
    <Box>
      <Formik
        initialValues={{ ...formik?.INITIAL_FORMIK_STATE }}
        validationSchema={formik?.FORM_VALIDATION}
        onSubmit={async values => {
          backdropRef?.current?.openAlert(true)
          backdropRef?.current?.loading(true)
          handleSaveFormik(
            values,
            properties,
            temporal,
            formik?.ITEMS_INCONVENIENCE_FORMIK,
            groupFieldAutocomplete,
            lnglat,
            TOKEN
          )
            .then(itsStored => {
              if (itsStored.stored) {
                backdropRef?.current?.success()
                backdropRef?.current?.loading(false)
              } else {
                setIsStored(itsStored)
                backdropRef?.current?.loading(false)
                backdropRef?.current?.openAlert(false)
              }
            })
            .catch(err => console.log('Error: ', err.message))
        }}>
        <Form>
          <Paper style={{ height: HEIGHT_PAPER, overflow: 'auto', borderRadius: 0 }}>
            <Box sx={styleForHeader}>
              <FormControlLabel
                control={<Switch {...propsSwitch} />}
                label={labelSwitch}
              />
              <Box>
                <Botton
                  text="Nuevo"
                  onClick={handleNewTreeForm}
                  startIcon={<Forest />}
                  styleButton={styleDefault(COLOR_SHOW, COLOR_WHITE)}
                  size="large"
                  disabled={isEditable}
                />
              </Box>
            </Box>
            <Divider />
            <Typography sx={styleTitle}>INFORMACIÓN GENERAL DEL ÁRBOL</Typography>
            <Divider />

            <Grid container spacing={2} sx={{ ...gridStyle }}>
              {formik?.ITEMS_GENERAL_FORMIK.map((o, i) => (
                <ItemsContainer key={`formik-${i}`} {...o} editable={isEditable} />
              ))}
            </Grid>
            <Divider sx={{ pt: 2 }} />
            <Typography sx={styleTitle}>UBICACIÓN Y MEDICIONES FENOTÍPICAS</Typography>
            <Divider />

            <Grid container spacing={2} sx={{ ...gridStyle }}>
              {formik?.ITEMS_ATTRIBUTES_FORMIK.map((o, i) => (
                <ItemsContainer key={`formik-inconv-${i}`} {...o} editable={isEditable} />
              ))}
            </Grid>
            <Divider sx={{ pt: 2 }} />
            <Typography sx={styleTitle}>
              ESTADO FITOSANITARIO, PROBLEMAS, <br /> RIESGOS, Y ACCIONES RECOMENDADAS
            </Typography>
            <Divider />
            <TabsContainer
              itemsfk={formik?.ITEMS_INCONVENIENCE_FORMIK}
              editable={isEditable}
            />
          </Paper>
          <BottonInside isEditable={isEditable} />
        </Form>
      </Formik>
      <AlertCustom
        ref={alertRef}
        severity={isStored?.stored !== true ? 'warning' : 'success'}>
        {isStored?.stored !== true ? isStored?.message : 'Guardado exitosamente.'}
      </AlertCustom>
      <Backdrop
        ref={backdropRef}
        treeId={isStored?.treeId}
        redirect={true}
        control={true}
      />
    </Box>
  )
}

export default React.memo(ItemsFormik)
